import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  userDetails: null,
  isPro: false,
  authModalForced: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      const payload = action.payload ?? null;

      // Allow both:
      // 1) dispatch(setUserDetails("uid"))
      // 2) dispatch(setUserDetails({ userId, email, name, ... }))
      const user =
        typeof payload === "string"
          ? { userId: payload }
          : typeof payload === "object"
          ? payload
          : null;

      state.userId = user?.userId ?? user?.uid ?? null;
      state.userDetails = user;

      state.isPro = Boolean(
        user?.isPro || user?.role === "pro" || user?.plan === "pro"
      );
    },

    upgradeToPro: (state) => {
      state.isPro = true;
      if (state.userDetails) state.userDetails.isPro = true;
    },

    downgradeToFree: (state) => {
      state.isPro = false;
      if (state.userDetails) state.userDetails.isPro = false;
    },

    logoutUser: () => initialState,

    sessionExpired: () => ({ ...initialState, authModalForced: true }),

    clearForcedAuthModal: (state) => {
      state.authModalForced = false;
    },
  },
});

export const {
  setUserDetails,
  upgradeToPro,
  downgradeToFree,
  logoutUser,
  sessionExpired,
  clearForcedAuthModal,
} = userSlice.actions;

export default userSlice.reducer;
